"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _overrides = require("../helpers/overrides");
var _styledComponents = require("./styled-components");
var _constants = require("./constants");
var _utils = require("./utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
const Badge = ({
  children,
  content,
  color,
  shape = _constants.SHAPE.rectangle,
  placement = _constants.PLACEMENT.topRight,
  hierarchy,
  horizontalOffset,
  verticalOffset,
  hidden,
  overrides = {}
}) => {
  const [Badge, badgeProps] = (0, _overrides.getOverrides)(overrides.Badge, _styledComponents.StyledBadge);
  const [Root, rootProps] = (0, _overrides.getOverrides)(overrides.Root, _styledComponents.StyledRoot);
  const [Positioner, positionerProps] = (0, _overrides.getOverrides)(overrides.Positioner, _styledComponents.StyledPositioner);
  const anchor = (0, _utils.getAnchorFromChildren)(children);
  const VALID_RECT_PLACEMENTS = [_constants.PLACEMENT.topLeft, _constants.PLACEMENT.topRight, _constants.PLACEMENT.bottomRight, _constants.PLACEMENT.bottomLeft];
  if (process.env.NODE_ENV !== "production") {
    if (shape === _constants.SHAPE.rectangle && !VALID_RECT_PLACEMENTS.includes(placement)) {
      console.warn('Rectangle badges should only be placed in a corner or used inline');
    }
    if (shape === _constants.SHAPE.rectangle && hierarchy === _constants.HIERARCHY.secondary && anchor) {
      console.warn('Secondary badges should not be positioned. Use the inline version of this badge instead.');
    }
    if (shape === _constants.SHAPE.pill && hierarchy === _constants.HIERARCHY.secondary) {
      console.warn('Pill badges should only be used with primary hierarchy');
    }
  }

  // If there's no anchor, render the badge inline
  if (!anchor) {
    return /*#__PURE__*/React.createElement(Badge, _extends({
      $hierarchy: hierarchy,
      $shape: shape,
      $color: color,
      $hidden: hidden
    }, badgeProps), content);
  }
  return /*#__PURE__*/React.createElement(Root, rootProps, anchor, /*#__PURE__*/React.createElement(Positioner, _extends({
    $horizontalOffset: horizontalOffset,
    $verticalOffset: verticalOffset,
    $placement: placement,
    $role: _constants.ROLE.badge
  }, positionerProps), /*#__PURE__*/React.createElement(Badge, _extends({
    $hierarchy: hierarchy,
    $shape: shape,
    $color: color,
    $hidden: hidden
  }, badgeProps), content)));
};
var _default = exports.default = Badge;